import { t } from '../../app/i18n';

export default {
  1: 'GENERATED',
  2: 'SENT'
}

export const translation = {
  GENERATED: t('Vygenerovaná'),
  SENT: t('Zaslaná')
};



// WEBPACK FOOTER //
// ./src/common/enums/messageStatus.js